module.exports = __webpack_public_path__ + "static/media/cloudcards.3e66067a.png";